import BaseObject from "./BaseObject";

import { groupBy } from "@/shared/utility.js"

export default class CreateEventCreationObject{
  static _objectDefinition() {
    return {
      eventId: null,
      name: "",
      type: "",
      // timeWindowType: "",
      // durationType: "",
      // tour: false,
      // relay: false,
      // main: false,
      deliveryPartner: "",
      eventPartner: "",
      eventRanking: null,
      duration: null,
      maxEventCapacity: null,
      eventBudget: null,
      locationId: "",
      infoUrl: "",
      endLocationId: "",
      owner: "",
      description: "",
      arrivalText: "",
      departureText: "",
      arrivalAudio: "",
      departureAudio: "",
      departureAudioUrl: "",
      picture: "",
      extraPictures: {},
      selectedTags: [],
      imageUrl: "",
      arrivalAudioName: {},
      arrivalAudioFile: {},
      arrivalAudioUrl: {},
      discountCards: {},
      productCategories: {},
      parentEvents: {},
      parentEventRewards: {},
      rewardLevels: {},
      planboardManaged: false,
      preEvent: false,
      externalPlatform: '',
      externalEvent: {},
      extraLocations: [],

      // averageSpeed: null,
      // chosenChildren: []
    };
  }

  static getPropertyId(name, columns) {
    for (let p in columns) {
      if (columns.hasOwnProperty(p) && p === name) {
        return columns[p];
      }
    }
  }

  static _createRequestObject(object, accounts, relay) {

    //if tags subArray contains more than just the number
    // if (object.selectedTags.length > 0) {
    //     let _selectedTags = {};
    //     object.selectedTags.forEach(element => {
    //       _selectedTags[element.id] = element.id;
    //     });
    //     object.selectedTags = _selectedTags;
    // }
    //   if (object.chosenChildren.length > 0) {
    //     let _chosenChildren = {};
    //     object.chosenChildren.forEach(element => {
    //       _chosenChildren[element.eventId] = element.eventId;
    //     });
    //     object.chosenChildren = _chosenChildren;
    // }
    // const tagsString = Object.assign({}, object.selectedTags);
    // const childrensString = Object.assign({}, object.chosenChildren);
    const requestObject = {};
    if (object.type === "Relay" || object.type === 'Tour') {

      this.requestObject = {
        Name: object.name,
        Type: object.type,
        // TimeWindowType: object.timeWindowType,
        // DurationType: object.durationType,
        EventRanking: Number(object.eventRanking),
        Duration: Number(object.durationMin * 60),
        EventBudget: Number(object.eventBudget),
        DeliveryPartner: object.deliveryPartner,
        PartnerId: Number(object.partnerId),
        PreEvent: object.preEvent,
        PreEventQuestion: object.preEventQuestion,
        MaxEventCapacity: Number(object.maxEventCapacity),
        LeadTime: object.leadTime,
        InfoUrl: object.infoUrl,
        // CooldownTime: object.cooldownTime,
        Owner: object.owner,
        Picture: object.picture,
        ExtraPictures: object.extraPictures,
        LocationId: object.locationId,
        Relay: {
          EndLocationId: object.endLocationId,
          TravelMode: relay.TravelMode,
          Distance: relay.Distance,
          Duration: relay.Duration,
          Waypoints: relay.waypoints,
          Path: relay.path,
          PathPoints: relay.PathPoints,
          Stops: relay.stops,
          AverageSpeed: relay.AverageSpeed
        },
        EndLocationId: object.endLocationId,
        Tags: object.selectedTags,
        DiscountCards: object.discountCards,
        ProductCategories: object.productCategories,
        RewardLevels: object.rewardLevels,
        Accounts: {},
        ParentEvents: object.parentEvents,
        ParentEventRewards: object.parentEventRewards,
        ExtraLocations: object.extraLocations,
        PlanboardManaged: Boolean(Number(object.planboardManaged))
      };
    } else {
      console.log("object ?!?!?!", object);
      this.requestObject = {
        Name: object.name,
        Type: object.type,
        // TimeWindowType: object.timeWindowType,
        // DurationType: object.durationType,
        EventRanking: Number(object.eventRanking),
        PreEvent: object.preEvent,
        PreEventQuestion: object.preEventQuestion,
        Duration: Number(object.durationMin * 60),
        EventBudget: Number(object.eventBudget),
        DeliveryPartner: object.deliveryPartner,
        PartnerId: Number(object.partnerId),
        MaxEventCapacity: Number(object.maxEventCapacity),
        LeadTime: object.leadTime,
        InfoUrl: object.infoUrl,
        // CooldownTime: object.cooldownTime,
        Owner: object.owner,
        Picture: object.picture,
        ExtraPictures: object.extraPictures,
        LocationId: object.locationId,
        EndLocationId: object.endLocationId,
        Tags: object.selectedTags,
        DiscountCards: object.discountCards,
        ProductCategories: object.productCategories,
        RewardLevels: object.rewardLevels,
        Accounts: {},
        ParentEvents: object.parentEvents,
        ParentEventRewards: object.parentEventRewards,
        ExtraLocations: object.extraLocations,
        PlanboardManaged: Boolean(Number(object.planboardManaged)),
      };

    }

    if(object.type === 'External'){
      console.log("Lorenzo kom ik hier doorheen", );
      this.requestObject.ExternalEventInfo = {
        EventBridge: object.externalPlatform,
          ExternalId: object.externalEvent.externalId,
          ExternalName: object.externalEvent.externalName,
      }
    }
    if (accounts.length > 0) {
      accounts.forEach(e => {
        this.requestObject.Accounts[e.accountId] = e.accountId;
      });
    }
    if (object.locationId === undefined) {
      this.requestObject.LocationId = "";
    }
    if (object.eventId !== null) {
      this.requestObject.EventId = object.eventId;
    }
    console.log("requestObject at createEventCreationObject", this.requestObject);
    return this.requestObject;
  }



  static _DeleteRequestObject(object) {
    let deleteRequestObject = {
      eventId: {
        datatype: "int",
        value: object.id
      }
    };
    return deleteRequestObject;
  }

  static _createArrayWithObjects(eventObject) {
    let result = BaseObject._createArrayWithObjects(eventObject);


    return result;
  }

  /**
   * function to parse the response for
   * editEventsDesc call
   */
  static _parseDescEvents(data) {
    let outputArray = [];

    if (!data.hasOwnProperty("EventDefs")) return outputArray;
    //
    // const src = JSON.parse(data.EventDefs.EventDefsList.value);
    outputArray = BaseObject._createArrayWithObjects(data.EventDefs);
    return outputArray;
  }


  static _createArrayWithObjects(event) {
    let members = [];
    if (event.MemberOf !== undefined && event.MemberOf.UserGroupsForEvent !== undefined) {
      members = BaseObject._toLowerCaseInitialProperty(BaseObject._createArrayWithObjects(event.MemberOf.UserGroupsForEvent));
    }

    let result = BaseObject._toLowerCaseObjectProperties(event);
    result.memberOf = members;
    return result;
  }
}
